import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientService } from '../../../../services/client.service';
import { SendMessageRequest } from '@rubii/sdk-web-agent/src/types/agent';
import { GenerateMappingResult } from '../types/generate-mapping';

@Component({
  selector: 'app-generate-mapping',
  templateUrl: './generate-mapping.component.html',
  styleUrls: ['./generate-mapping.component.scss']
})
export class GenerateMappingComponent implements OnInit {

  clientId = '';
  isGenerating = false;
  error: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private client: ClientService,
  ) { }

  ngOnInit(): void {
    const uuid = this.route.snapshot.paramMap.get('uuid');
    if (!uuid) {
      this.router.navigate(['/datasources/custom/upload']);
      return;
    }
    this.clientId = uuid;
    this.generate();
  }

  async generate(): Promise<void> {
    this.isGenerating = true;
    this.error = null;

    const request = new SendMessageRequest();
    request.message = 'Generate field mapping for this data source file';
    request.clientId = this.clientId;
    request.skill = 'datasource/media-file-import/generate-mapping';
    request.responseFormat = 'json';

    try {
      const result = await this.client.agent.sendJsonQuery<GenerateMappingResult>(request);
      sessionStorage.setItem('data-source-custom-mapping-result-' + this.clientId, JSON.stringify(result));
      this.router.navigate(['/datasources/custom/mapping-result', this.clientId]);
    } catch (err) {
      console.error('Mapping generation failed:', err);
      this.error = 'Mapping generation failed. Please try again.';
    } finally {
      this.isGenerating = false;
    }
  }
}
